import React from 'react'
import { Field } from "redux-form";
import {
    TextField
  } from "redux-form-material-ui";
import "./styles.css"


const stylesMUI = {
    detailsTable: {
      margin: "5% 0"
    },
    inputStyle: {
      fontWeight: "400",
      fontFamily: '"Montserrat", sans-serif'
    }
  };

const ContactInfoForm = () => (
    <div class="contact-info-form">
      <Field
        class="contact-info-form__item"
        name="email"
        component={TextField}
        floatingLabelText="Email"
        hintStyle={stylesMUI.inputStyle}
        inputStyle={stylesMUI.inputStyle}
        floatingLabelStyle={stylesMUI.inputStyle}
        fullWidth
      />
      <Field
        class="contact-info-form__item"
        name="phone"
        component={TextField}
        floatingLabelText="Phone"
        hintStyle={stylesMUI.inputStyle}
        inputStyle={stylesMUI.inputStyle}
        floatingLabelStyle={stylesMUI.inputStyle}
        fullWidth
      />
    </div>

) 

export default ContactInfoForm


// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/components/ContactInfoForm/index.js